// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the ApiServices.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
import BaseApi from './BaseApi';
import TableRequestDTO from '../models/TableRequestDTO';
import TableResponseDTO from '../models/TableResponseDTO';
import AdminFilingPeriodHistoryDTO from '../models/AdminFilingPeriodHistoryDTO';

export class FilingPeriodHistoryApiService extends BaseApi {

  // post: api/fph/table?committeeId=${encodeURIComponent(committeeId)}
  public getPeriodHistory(tableRequest: TableRequestDTO, committeeId: string): Promise<TableResponseDTO<AdminFilingPeriodHistoryDTO>> {
    let url = `api/fph/table`;
    let prefix = url.indexOf('?') > 0 ? '&' : '?';
    if (committeeId != null) {
      url += `${prefix}committeeId=${encodeURIComponent(committeeId)}`;
      prefix = '&';
    }

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, TableResponseDTO<AdminFilingPeriodHistoryDTO>>(tableRequest, 'post', url, true, false);
  }

  // delete: api/fph/${encodeURIComponent(dr2Id)}?committeeId=${encodeURIComponent(committeeId)}
  public deleteFph(dr2Id: string, committeeId: string): Promise<void> {
    let url = `api/fph/${encodeURIComponent(dr2Id)}`;
    let prefix = url.indexOf('?') > 0 ? '&' : '?';
    if (committeeId != null) {
      url += `${prefix}committeeId=${encodeURIComponent(committeeId)}`;
      prefix = '&';
    }

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, void>(null, 'delete', url, true, false);
  }

  // post: api/fph/${encodeURIComponent(dr2Id)}/status?committeeId=${encodeURIComponent(committeeId)}
  public updateStatus(dr2Id: string, committeeId: string): Promise<void> {
    let url = `api/fph/${encodeURIComponent(dr2Id)}/status`;
    let prefix = url.indexOf('?') > 0 ? '&' : '?';
    if (committeeId != null) {
      url += `${prefix}committeeId=${encodeURIComponent(committeeId)}`;
      prefix = '&';
    }

    url = url.replace(/null|undefined/gi, '');
    return this.SendRequest<any, void>(null, 'post', url, true, false);
  }
}
var service = new FilingPeriodHistoryApiService();
export default service;
